import { sendRequest } from "../sendRequest";

export const updateUserV2 = (userProps) => {
  return sendRequest("put", `/influencer/me/`, userProps, undefined, true).then(
    (res) => res.data
  );
};
